export enum CncAdsPage {
  ALL = 'all',
  HOMEPAGE = 'homepage',
  SECTION = 'section',
  SEARCH = 'search',
  AUTHOR = 'author',
  NEWSROOM = 'newsroom',
  NEWSLETTER = 'newsletter',
  NEWSLETTER_CONFIRMATION = 'newsletter_confirmation',
  ARTICLE_DETAIL = 'article_detail',
  ARTICLE_GALLERY = 'article_gallery',
  PROFILE = 'profile',
  ERROR = 'ERROR'
}